import { render, staticRenderFns } from "./PriceSummary.vue?vue&type=template&id=d5d83aca"
import script from "./PriceSummary.vue?vue&type=script&lang=js"
export * from "./PriceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductDetailsMinimumPrice: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Product/Details/MinimumPrice.vue').default})
